import { setIn } from "formik";
import { string } from "yup";

const transformApiFieldErrors = (apiErrors: any) => {

    let errors = {};

    Object.entries(apiErrors).forEach( ([Key, value]) => {
        if(!!Key) {
            errors = setIn(errors, Key, value);
        }
    });

    if(Object.keys(errors).length === 0) {
        return undefined;
    }
    
    errors = decapitalizeFirstLetter(errors);
    console.log(errors);

    return errors;
}

const transformApiGlobalErrors = (apiErrors: any) => {

    let errors: Array<string> = [];

    Object.entries(apiErrors).forEach( ([Key, value]) => {
        //if(Key === '' || Key === undefined) {
            if(Array.isArray(value) && value.length > 0 && value.every(item => typeof item === "string")) {
                errors = errors.concat(value);
            }
        //}
    });


    return errors;
}

const decapitalizeFirstLetter = (o: any) => {
    let newO = {}
    let obj: Record<string, any> = {};

    var origKey, newKey, value;

    if (o instanceof Array) {
      return o.map(function(value) {
          if (typeof value === "object") {
            value = decapitalizeFirstLetter(value)
          }
          return value
      })
    } else {
      newO = {}
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
          value = o[origKey]
          if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = decapitalizeFirstLetter(value)
          }

          Object.defineProperty(newO, newKey, {
            value: value,
            writable: true, enumerable: true, configurable: true
          });
        }
      }
    }
    return newO
  }


export {transformApiFieldErrors, transformApiGlobalErrors};
